export default "__VITE_ASSET__DHW3Ztxt__"